import assign from "lodash/fp/assign";
import isNaN from "lodash/fp/isNaN";
import isNil from "lodash/fp/isNil";

import cloneDeep from "lodash/fp/cloneDeep";
import {
  toPhoneObject,
  multiplyFloatingPointByCurrency,
} from "../../core/utils";
import constants from "../../core/constants";

class Controller {
  constructor(Events, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    this.emailRegExpPattern =
      this.type === "email" ? constants.RegExp.email : null;

    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to remove "${this.name}"?`)
      .textContent("If you chose to remove it you can add it again.")
      .ok("Remove")
      .cancel("Cancel");
    this.isChecked = Boolean(this.selected && !isNil(this.selected.value));

    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.onClear = () => {
      this.$mdDialog.show(confirm).then(
        () => {
          this.selected.value = null;
          this.Events.emit(this.eventName, this.selected);
        },
        () => {}
      );
    };

    this.submitField = () => {
      this.selected.isDisabled = true;
      const clonedSelected = cloneDeep(this.selected) || {};
      clonedSelected.key = this.name || clonedSelected.key;
      if (this.currency && !isNil(this.selected.value)) {
        clonedSelected.value = multiplyFloatingPointByCurrency(
          clonedSelected.value
        );
      }
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;
      const result = assign(clonedSelected, { method, methodName });
      if (this.isPhoneObject && this.city) {
        result.value = toPhoneObject(result.value, this.city);
      }
      if (this.isConditional) {
        if (this.isChecked) {
          if (isNaN(result.value)) {
            this.Events.emit(errorEvent, {
              message:
                "Please provide a value for the captain price or disable the checkbox",
            });
            return;
          }
        } else {
          result.value = null;
        }
      }
      if (this.extraParams) result.extraParams = this.extraParams;
      this.Events.emit(this.eventName, result);
    };
  }
  toggleValue() {
    if (this.isChecked) {
      this.selected.value = this.tempValue;
    } else {
      this.tempValue = this.selected.value;
      this.selected.value = null;
    }
  }

  submitOnEnter({ key }, { $valid }) {
    if (key === "Enter" && $valid) this.submitField();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableField/editableField.controller.js